import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "potSizeWrapper" }
const _hoisted_2 = { class: "elevation-1 chartWrapper potSizeCard" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_base_chart = _resolveComponent("base-chart")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.noDataAlert,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.noDataAlert) = $event)),
      timeout: 3000,
      color: "primary",
      location: "top"
    }, {
      default: _withCtx(() => [
        _cache[11] || (_cache[11] = _createElementVNode("h3", null, "No data available for this range", -1)),
        _createVNode(_component_v_btn, {
          color: "blue",
          variant: "text",
          class: "d-flex ml-auto",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.noDataAlert = false))
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.pdfTimeoutError,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pdfTimeoutError) = $event)),
      timeout: 3000,
      color: "primary",
      location: "top"
    }, {
      default: _withCtx(() => [
        _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Error downloading requested pdf. Please try again.", -1)),
        _createVNode(_component_v_btn, {
          color: "blue",
          variant: "text",
          class: "d-flex ml-auto",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pdfTimeoutError = false))
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode(" Close ", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "chart-title d-block text-center" }, "Effect of Pot Size", -1)),
        _createVNode(_component_base_chart, {
          options: _ctx.chartOptions,
          "scroll-options": _ctx.chartSize,
          onClick: _cache[4] || (_cache[4] = (e) => _ctx.chartClick(e))
        }, null, 8, ["options", "scroll-options"])
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.membersDialog,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.membersDialog) = $event)),
      "onClick:outside": _cache[9] || (_cache[9] = ($event: any) => (_ctx.membersDialog = false)),
      persistent: "",
      "max-width": "80vw",
      "max-height": "90%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "py-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between" }, {
              default: _withCtx(() => [
                _cache[18] || (_cache[18] = _createElementVNode("div", null, [
                  _createElementVNode("div", null, "Member Analysis for the selected range:")
                ], -1)),
                _createElementVNode("div", null, [
                  _createVNode(_component_v_btn, {
                    left: "",
                    color: "primary",
                    class: "mr-4",
                    disabled: !_ctx.provider || _ctx.isSampleReport,
                    loading: _ctx.processingCSV,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.exportMemberCSV()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        small: "",
                        class: "mr-3"
                      }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode("fas fas fa-file-download", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[16] || (_cache[16] = _createTextVNode("Download ", -1))
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"]),
                  _createVNode(_component_v_btn, {
                    rounded: "",
                    size: "small",
                    density: "comfortable",
                    variant: "flat",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.membersDialog = false))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { small: "" }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("fa fa-times", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_AppTable, {
                  "table-data": _ctx.membersTableData,
                  disableSort: true,
                  disablePagination: true,
                  "default-sort-column": [{ key: 'dataId', order: 'asc' }]
                }, null, 8, ["table-data"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  color: "grey-darken-1",
                  variant: "text",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.membersDialog = false))
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode("Close", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.fetchingMembersAnalysis)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}